//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FfBreadcb from "@/pccomponents/FfBreadcb"
import formValidate from "@/js/formValidate";
import * as auth from "@/utils/auth";
export default {
  name: "modutree",
  components: {
    FfBreadcb,
  },
  data(){
    return {
      showMain:false,//是否显示主页面
      showDelete:false,//是否显示删除按钮
      
      formTipArray:[],//规则校验弹出框的值
      aFormValidateTip:[],//校验所需

      //后台返回的参数
      responseData:{
        record:{},//主表数据-基本信息
        record2:{},//默认权限
        rowlist:[],//特殊权限
        edititems:'',
        notNullItems:''
      },
      testRoleIds:'',
      editItemShow:true,//控制responseData.rowlist行项新增删除
      rules: {},

      //下拉框初始化
      ifrulecontrol:[],//是否权限控制
      modutype:[],//模块类型
      rightlevel:[],//默认权限类型
      queryLevel:[],//默认查询范围
      moduSystemList:[],//默认对应模块系统
      flowsysid:'FLOW',
      scon:'',
      sconSysid:'',//菜单树传值
      vcon:''
    }
  },
  methods: {
    /**
     * 查询右侧列表记录
     */
    queryList(id,hasMenuid){
      let url = "modu/load";
      let params = {
        moduid:id,
        hasMenuid:hasMenuid,
        flowsysid:this.flowsysid
      }
      //请求后端数据
      this.axios.post(url, params).then(({ data }) => {
        //为可编辑域赋值
        this.responseData.edititems=data.data.edititems;
        //为表单校验规则赋值
        formValidate.initViewInfo4NotFlow(this,data.data.formValidateInfo);
        this.responseData.notNullItems=data.data.notNullItems;

        console.log('2019年11月22日11:10:48 modutree.vue[查询右侧列表记录]——[data] :',data);
        //为主表赋值
        this.responseData.record=data.data.record;
        this.responseData.record.applyareacode=data.data.applyareacode;//将后台要取的地址放入主表单
        this.responseData.record.delRowIDs=[];

        //为默认权限表赋值
        this.responseData.record2=data.data.record2;

        //为特殊权限表赋值
        this.responseData.rowlist=data.data.rowlist;

        this.showMain=true;
        this.showDelete=true;
      });
    },
    /**
     * 点击树节点
     */
    clickTree(data) {
      if(data.isParent=='false'){
        let hasMenuid=true;
        if(data.pId=='OTHER'){
          hasMenuid=false;
        }
        let id=data.id;
        this.queryList(id,hasMenuid);
      }
    },
    /**
     * 暂存模块配置信息
     */
    saveModuData(){
       //let isValidateSucc = formValidate.checkFormSave4NotFlow(this,'responseData');
      // if(isValidateSucc){
      //   //去除空行
        this.delNullLineByColumn(this.responseData,'rowlist','rolecode');
        
         let url = "modu/save";
         let params = {
           record:this.responseData.record,
          record2:this.responseData.record2,
           rowlist:this.responseData.rowlist,
           flowsysid:this.flowsysid
         }
         //请求后端数据
        this.axios.post(url, params).then(({ data }) => {
           if(data.code=='1'){
             this.tipRight(this.$t('formValidate.success'),this.$t('formValidate.savesuccess'),'success');
             
             /** setTimeout(()=>{  
                location.reload();
             },1000);**/
           }
         });
    },
    /**
     * 更新特殊权限列表
     */
    updateRowlist(params){
      //删除当前行
      if(params.returnData.length!=0){
        this.responseData.record.delRowIDs.push(this.responseData.rowlist[params.rowindex].checkrightid);
        this.responseData.rowlist.splice(params.rowindex,1);
      }

      for(let i=params.returnData.length-1;i>=0;i--){
        let obj={};
        obj['areacode']=params.returnData[i]['areacode'];
        obj['rolecode']=params.returnData[i]['rolecode'];
        obj['roledesc']=params.returnData[i]['roledesc'];
        obj['roleid']=params.returnData[i]['roleid'];
        
        obj['rolename']=params.returnData[i]['rolename'];
        if(this.isNotNullOrEmpty(params.returnData[i]['roleid'])){
          this.getCheckRightData(params.returnData[i]['roleid']).then(data=>{
            if(data!=''){
              obj['queryLevel']='queryLevel' in data?data.queryLevel:'SELF_PROV';
              obj['rightlevel']='rightlevel' in data?data.rightlevel:'1';
              this.responseData.rowlist.splice(params.rowindex,0,obj);
            }else{
              console.log('2019年11月25日18:34:12 modutree.vue[特殊权限获取失败]——[null] :',null);
            }
          });
        }

        //去除空行
        this.delNullLineByColumn(this.responseData,'rowlist','rolecode');
      }
    },
    /**
     * 通过roleid获取相应权限信息
     */
    async getCheckRightData(roleid){
      
      let url = "modu/getCheckRightData";
      let params = {
        moduid:this.responseData.record.moduid,
        sysid:this.responseData.record.sysid,
        flowsysid:this.flowsysid,
        roleid:roleid
      }
      //请求后端数据
      let data=await this.axios.post(url, params).then(({ data }) => {
        if(data.code=='1'){
          return data;
        }else{
          console.log('2019年11月18日20:24:09 modutree.js[后台获取特殊权限失败]——[data.msg] :', data.msg);
          return '';
        }
      }).catch((error) => {
        console.log('2019年11月18日20:24:09 modutree.js[前台获取特殊权限失败]——[error] :', error);
        return '';
      });
      if(data!=''){
        return data.data;
      }else{
        return '';
      }
    },
    /**
     * 新增模块配置
     */
    addAction(){
      let url = "modu/loadAdd";
      let params = {flowsysid:this.flowsysid}
      //请求后端数据
      this.axios.post(url, params).then(({ data }) => {
        console.log('2019年12月03日17:28:10 modutree.vue[描述]——[data] :',data);
        //为可编辑域赋值
        this.responseData.edititems=data.data.edititems;
        //为表单校验规则赋值
        formValidate.initViewInfo4NotFlow(this,data.data.formValidateInfo);
        this.responseData.notNullItems=data.data.notNullItems;
        
        //初始化主表
        this.responseData.record=data.data.record;
        this.responseData.record.applyareacode=data.data.applyareacode;//将后台要取的地址放入主表单
        this.responseData.record.delRowIDs=[];

        //初始化默认权限表
        this.responseData.record2={};

        //初始化特殊权限表
        this.responseData.rowlist=[];

        this.showMain=true;
        this.showDelete=false;
      });
    },
    /**
     * 删除模块配置
     */
    delAction(){
      console.log('2019年12月03日19:35:37 modutree.vue[描述]——[this.responseData] :',this.responseData);
      let url = "modu/delete";
      let params = {
        billids:this.responseData.record.moduid,
        flowsysid:this.flowsysid,
      };
      this.axios.post(url, params).then(({ data }) => {
        if(data.code=='1'){
          this.tipRight(this.$t('formValidate.success'),'Delete Successfully','success');
          setTimeout(()=>{  
            location.reload();
          },1000);
        }else{
          console.log('2019年11月20日19:33:55 role.vue[删除失败]——[null] :',null);
        }
      }).catch(function(error){
        console.log(error)//错误处理 相当于error
      })
    },
    refresh(){
        let params = {
          modulid:this.responseData.record.moduid,
          areacode:this.responseData.record2.areacode,
          modusystem:this.responseData.record.modusystem,
          flowsysid:this.flowsysid
        };
        let url = "modu/refreshCash";
        this.axios.post(url, params).then(({ data }) => {
          if(data.code=='1'){
            this.tipRight(this.$t('formValidate.success'),'refesh success','success');
           /** setTimeout(()=>{  
              location.reload();
            },1000);**/
          }else{
            console.log('2019年11月20日19:33:55 role.vue[删除失败]——[null] :',null);
          }
        }).catch(function(error){
          console.log(error)//错误处理 相当于error
        })

    }
  },
  created(){
    //初始化下拉框
    let requestJsonData = []; 
    let paramArray1 = {
      showcode:'ifrulecontrol',
      selectcode:'SYS_CDFCODECONFIG',
      hasnull:true,
      paras:{"paras0":"YESORNO","paras1":"1"}
    };
    let paramArray2 = {
      showcode:'modutype',
      selectcode:'SYS_CDFCODECONFIG',
      hasnull:true,
      paras:{"paras0":"MODUTYPE","paras1":"1"}
    };
    let paramArray3 = {
      showcode:'rightlevel',
      selectcode:'SYS_CDFCODECONFIG',
      hasnull:true,
      paras:{"paras0":"DEPTRIGHT","paras1":"1"}
    };
    let paramArray4 = {
      showcode:'queryLevel',
      selectcode:'SYS_CDFCODECONFIG',
      hasnull:true,
      paras:{"paras0":"DEPTQUERY","paras1":"1"}
    };
     let paramArray5 = {
      showcode:'moduSystemList',
      selectcode:'SYS_CDFCODECONFIG',
      hasnull:true,
      paras:{"paras0":"MODUSYSTEM","paras1":"1"},
      flowsysid:this.flowsysid
    };
    requestJsonData.push(paramArray1);
    requestJsonData.push(paramArray2);
    requestJsonData.push(paramArray3);
    requestJsonData.push(paramArray4);
    requestJsonData.push(paramArray5);
    this.initDropDown(this,requestJsonData);
    this.sconSysid=process.env.SYS_NAME;
    //this.scon="sysid:"+process.env.SYS_NAME;
    this.vcon = process.env.SYS_NAME;
  },
  mounted() {
    
  }
}



// WEBPACK FOOTER //
// ./src/pcpage/ptooa/permission/modutree.vue